import type { TourSide } from '@/features/onboarding-tour';

export interface Box {
  top: number;
  left: number;
  width: number;
  height: number;
}

const GAP = 14;
const EDGE = 12;

export function placeCard(
  anchor: Box,
  card: { width: number; height: number },
  viewport: { width: number; height: number },
  side: TourSide,
): { top: number; left: number } {
  const clampX = (x: number) => Math.min(Math.max(x, EDGE), viewport.width - card.width - EDGE);
  const clampY = (y: number) => Math.min(Math.max(y, EDGE), viewport.height - card.height - EDGE);

  const right = anchor.left + anchor.width + GAP;
  if (side === 'right' && right + card.width + EDGE <= viewport.width) {
    return { top: clampY(anchor.top), left: right };
  }
  const below = anchor.top + anchor.height + GAP;
  if (below + card.height + EDGE <= viewport.height) {
    return { top: below, left: clampX(anchor.left + anchor.width - card.width) };
  }
  return { top: clampY(anchor.top - GAP - card.height), left: clampX(anchor.left + anchor.width - card.width) };
}
